import { render, staticRenderFns } from "./JButton.vue?vue&type=template&id=449c0fc4&scoped=true&"
import script from "./JButton.vue?vue&type=script&lang=js&"
export * from "./JButton.vue?vue&type=script&lang=js&"
import style0 from "./JButton.vue?vue&type=style&index=0&id=449c0fc4&prod&lang=scss&"
import style1 from "./JButton.vue?vue&type=style&index=1&id=449c0fc4&prod&scoped=true&lang=scss&"
import style2 from "./JButton.vue?vue&type=style&index=2&id=449c0fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c0fc4",
  null
  
)

export default component.exports